{
  "version": 1,
  "asset_id": "e818540a-bee7-4643-bf3a-79c4d48c9a83",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e818540a-bee7-4643-bf3a-79c4d48c9a83/sleeve-dissection-revision.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e818540a-bee7-4643-bf3a-79c4d48c9a83/sleeve-dissection-revision.png",
  "original_filename": "sleeve-dissection-revision.png",
  "size": 689410,
  "content_type": "image/png",
  "created_at": "2026-10-05T12:42:56Z"
}
